import { AbstractControl, ValidatorFn } from '@angular/forms';
import PhoneNumber from 'awesome-phonenumber';

// @dynamic
export class PhoneValidator {
  static validCountryPhone(regionIso: string): ValidatorFn {
    return (phoneControl: AbstractControl): { [key: string]: boolean } => {
      if (phoneControl.value && phoneControl.value !== '') {
        try {
          const phoneNumber = new PhoneNumber(phoneControl.value, regionIso);

          const isValidNumber = phoneNumber.isValid();

          if (isValidNumber) {
            return undefined;
          }
        } catch (e) {
          console.log(e);
          return {
            validCountryPhone: true,
          };
        }

        return {
          validCountryPhone: true,
        };
      } else {
        return undefined;
      }
    };
  }
}
